import React, { useLayoutEffect, useState } from 'react';
import { Router } from 'react-router-dom';
import type { History, Action, Location } from 'history';

type HistoryRouterProps = {
  history: History;
  children: React.ReactNode;
};

/**
 * A custom router component that works with React Router v7 and a custom history instance.
 * This bridges the gap between the history v5 API and the new React Router v7 API.
 */
export function HistoryRouter({ history, children }: HistoryRouterProps) {
  const [state, setState] = useState<{ action: Action; location: Location }>({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => {
    return history.listen(({ location, action }) => {
      setState({ action, location });
    });
  }, [history]);

  return (
    <Router
      navigator={history}
      location={state.location}
      navigationType={state.action}
    >
      {children}
    </Router>
  );
}
